/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export { default as CleanIconButtonActive } from './clean-icon-button-active.story';
export { default as CleanIconButtonDefault } from './clean-icon-button-default.story';
export { default as CleanIconButtonDisabled } from './clean-icon-button-disabled.story';
export { default as CleanIconButtonLoading } from './clean-icon-button-loading.story';
export { default as CleanIconButtonSizes } from './clean-icon-button-sizes.story';
export { default as CleanIconButtonTone } from './clean-icon-button-tone.story';
export { default as CleanIconButtonKeyboardDisplay } from './clean-icon-button-keyboard-display.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import CleanIconButtonActiveSrcRaw from './clean-icon-button-active.story?raw';
import CleanIconButtonDefaultSrcRaw from './clean-icon-button-default.story?raw';
import CleanIconButtonDisabledSrcRaw from './clean-icon-button-disabled.story?raw';
import CleanIconButtonKeyboardDisplaySrcRaw from './clean-icon-button-keyboard-display.story?raw';
import CleanIconButtonLoadingSrcRaw from './clean-icon-button-loading.story?raw';
import CleanIconButtonSizesSrcRaw from './clean-icon-button-sizes.story?raw';
import CleanIconButtonToneSrcRaw from './clean-icon-button-tone.story?raw';

export const CleanIconButtonActiveSrc = removeLicenseHeader(
  CleanIconButtonActiveSrcRaw,
);
export const CleanIconButtonDefaultSrc = removeLicenseHeader(
  CleanIconButtonDefaultSrcRaw,
);
export const CleanIconButtonDisabledSrc = removeLicenseHeader(
  CleanIconButtonDisabledSrcRaw,
);
export const CleanIconButtonLoadingSrc = removeLicenseHeader(
  CleanIconButtonLoadingSrcRaw,
);
export const CleanIconButtonSizesSrc = removeLicenseHeader(
  CleanIconButtonSizesSrcRaw,
);
export const CleanIconButtonToneSrc = removeLicenseHeader(
  CleanIconButtonToneSrcRaw,
);
export const CleanIconButtonKeyboardDisplaySrc = removeLicenseHeader(
  CleanIconButtonKeyboardDisplaySrcRaw,
);
